export default __webpack_public_path__ + "static/media/success_icon.145e62c1.svg";